export const FORM_VALIDATIONS = {
  email: {
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
      message: '잘못된 이메일 주소입니다.',
    },
    required: '이메일을 입력해주세요.',
  },
  hyperLink: {
    pattern: {
      value:
        /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$/,
      message:
        '올바른 URL 형식이 아닙니다. http:// 또는 https:// 로 시작하는 링크를 입력하세요.',
    },
    required: '링크를 입력해주세요.',
  },
  memo: {
    maxLength: {
      value: 500,
      message: '메모는 500자 이내로 입력해주세요.',
    },
  },
} as const;

/**
 * 고객 등록·수정의 신원 필수 조건 안내 문구.
 *
 * 서버 정책이 "고객명·연락처·회사명 중 하나" → "고객명·연락처·회사명·이메일 중 하나"로
 * 완화되면서, 같은 조건을 3개 화면이 제각각 표기하던 것을 한 곳으로 모은다.
 * 표기 순서는 폼의 필드 배치 순서를 따른다.
 */
export const CLIENT_IDENTITY_REQUIRED_MESSAGE =
  '고객 이름, 회사명, 연락처, 이메일 중 하나는 필수입니다.';
